module.exports = __webpack_public_path__ + "media/images/ll-icon-80f1c82b9b4262a6cbd751573ea802a2.svg";